<!--运单详情-->
<template>
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="itemBtn btnColor" @click="kehugenzong"
          >客服追踪</el-button
        >
        <el-button class="itemBtn btnColor" @click="uploadFIle()"
          >上传附件</el-button
        >
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <!-- 时间组件 -->
        <el-form-item class="queryItemsTimes" style="width: 550px">
          <multitime
            style="width: 550px"
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          ></multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="运单号:">
          <el-input
            clearable
            v-model="queryData.waybillNumber"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="客户单号:">
          <el-input
            clearable
            v-model="queryData.customereOrderNumber"
            placeholder="请输入"
            @keyup.enter.native="queryBtn_ok"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item class="queryItems" label="客户编号:">
          <el-input
            clearable
            v-model="queryData.customerNumber"
            placeholder="请输入"
          ></el-input>
        </el-form-item>-->
        <el-form-item class="queryItems" label="客户名称:">
          <el-select
            filterable
            clearable
            v-model="queryData.customerNumber"
            placeholder="请输入客户名称"
            remote
            :remote-method="getCustomerList"
            @change="changeCustomerNumber"
          >
            <el-option
              v-for="(item, index) in CustomerLists"
              :key="index"
              :label="item.name"
              :value="item.number"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="运单状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.waybillStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in waybillStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="queryItems" label="在途状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.onwayStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in OnwayStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="当前网点:">
          <el-select
            filterable
            clearable
            v-model="queryData.currentDeptId"
            placeholder="请输入"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in storageList"
              :key="index"
              :label="item.name"
              :value="item.documentId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="外发承运商:">
          <el-select
            filterable
            clearable
            v-model="queryData.carrierName"
            placeholder="请输入"
            remote
            :remote-method="getCarrierList"
            @change="changeCarrier"
          >
            <el-option
              v-for="(item, index) in CarrierLists"
              :key="index"
              :label="item.carrierName"
              :value="item.carrierName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="外发状态:">
          <el-select
            filterable
            clearable
            v-model="queryData.outgoingStatus"
            placeholder="请输入"
            @change="queryBtn_ok"
          >
            <el-option
              v-for="(item, index) in OutgoingStatusList"
              :key="index"
              :label="item.showName"
              :value="item.statusVal"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="contentInner">
      <!-- 左边列表 -->
      <div class="rightInner">
        <el-table
          :data="expressData"
          border
          ref="mytable"
          @row-dblclick="dblclick"
          highlight-current-row
          stripe
          size="small"
          :height="tableHeigth"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            align="center"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            align="center"
            :show-overflow-tooltip="true"
            label="运单号"
            width="149"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="双击查看详情"
                placement="top-start"
              >
                <div
                  :class="
                    scope.row.waybillSplitId == waybillSplitId
                      ? 'activeLeft'
                      : ''
                  "
                >
                  {{ scope.row.waybillNumber }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total,prev, next"
          prev-text="上一页"
          next-text="下一页"
          :current-page="pageStart"
          :total="pageCount"
          :page-size="pageTotal"
          @size-change="psc"
          @current-change="pcc"
        ></el-pagination>
      </div>
      <!-- 右边 -->
      <div class="leftInner">
        <el-tabs
          v-model="activeName"
          @tab-click="clickActiveName"
          type="card"
          stretch
          :style="'height:' + tableHeigth + 'px'"
        >
          <el-tab-pane label="运单信息" name="first">
            <!-- 基础信息 -->
            <el-descriptions title="基础信息" :column="4" border size="medium">
              <el-descriptions-item label="运单号">
                {{ packageDetail.baseInfoVo.waybillNumber }}
              </el-descriptions-item>
              <el-descriptions-item label="客户单号">
                <el-tooltip
                  :content="packageDetail.baseInfoVo.customerOrderNumber"
                >
                  <span class="desclass">{{
                    packageDetail.baseInfoVo.customerOrderNumber
                  }}</span>
                </el-tooltip>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="源单号"
                >{{ packageDetail.baseInfoVo.commandNumber }}
              </el-descriptions-item>-->
              <el-descriptions-item label="提货日期">{{
                packageDetail.baseInfoVo.takeTime
              }}</el-descriptions-item>
              <el-descriptions-item label="业务日期">{{
                packageDetail.baseInfoVo.businessDate
              }}</el-descriptions-item>
              <el-descriptions-item label="报价方式">{{
                packageDetail.baseInfoVo.channelName
              }}</el-descriptions-item>
              <el-descriptions-item label="报价到货区域">{{
                packageDetail.baseInfoVo.channelArrivalArea
              }}</el-descriptions-item>
              <el-descriptions-item label="提货单号">{{
                packageDetail.baseInfoVo.commandNumber
              }}</el-descriptions-item>
              <el-descriptions-item label="提货人员">{{
                packageDetail.baseInfoVo.takeUserName
              }}</el-descriptions-item>
              <el-descriptions-item label="收货方式">{{
                packageDetail.baseInfoVo.receiveMethod
              }}</el-descriptions-item>
              <el-descriptions-item label="交货方式">{{
                packageDetail.baseInfoVo.sendMethod
              }}</el-descriptions-item>
              <el-descriptions-item label="交货日期">{{
                packageDetail.baseInfoVo.deliveryTime
              }}</el-descriptions-item>
              <el-descriptions-item label="客户名称">{{
                packageDetail.baseInfoVo.customerName || 0
              }}</el-descriptions-item>
              <el-descriptions-item label="到货区域">{{
                packageDetail.baseInfoVo.arrivalArea
              }}</el-descriptions-item>
              <!-- <el-descriptions-item label="到货区域编号"
                >{{ packageDetail.baseInfoVo.arrivalAreaCode }}
              </el-descriptions-item>-->
              <el-descriptions-item label="运输方式">{{
                packageDetail.baseInfoVo.transportMethod
              }}</el-descriptions-item>
              <el-descriptions-item label="回单要求">{{
                packageDetail.baseInfoVo.rnRequireName
              }}</el-descriptions-item>
              <el-descriptions-item label="回单份数">{{
                packageDetail.baseInfoVo.rnRequireCount
              }}</el-descriptions-item>
              <el-descriptions-item label="创建人">{{
                packageDetail.baseInfoVo.createUserName
              }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{
                packageDetail.baseInfoVo.createTime
              }}</el-descriptions-item>
              <!-- <el-descriptions-item label="发货单位"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="发货人"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="发货人电话"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="发货地址"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="收货单位"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="收货人"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="收货人电话"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>
              <el-descriptions-item label="收货地址"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>-->
              <!-- <el-descriptions-item label="运输要求"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>-->
              <el-descriptions-item label="开单备注">{{
                packageDetail.baseInfoVo.remarks
              }}</el-descriptions-item>
              <el-descriptions-item label="是否分拣包装">{{
                packageDetail.baseInfoVo.isSorting
              }}</el-descriptions-item>
              <el-descriptions-item label="运费">{{
                packageDetail.baseInfoVo.totalFreight
              }}</el-descriptions-item>
              <el-descriptions-item label="付款方式">{{
                packageDetail.baseInfoVo.settlementMethod
              }}</el-descriptions-item>
              <!-- <el-descriptions-item label="是否开票"
                >{{ packageDetail.baseInfoVo.aaaa }}
              </el-descriptions-item>-->
              <el-descriptions-item label="是否投保">{{
                packageDetail.baseInfoVo.isInsureShow
              }}</el-descriptions-item>
              <el-descriptions-item label="声明价值">{{
                packageDetail.baseInfoVo.declaredValue
              }}</el-descriptions-item>
              <el-descriptions-item label="声明价值费率">{{
                packageDetail.baseInfoVo.declaredValueRate
              }}</el-descriptions-item>
              <el-descriptions-item label="保险费">{{
                packageDetail.baseInfoVo.insuranceFee
              }}</el-descriptions-item>
              <el-descriptions-item label="运单图片">
                <div
                  v-if="
                    packageDetail.fileVoList &&
                      packageDetail.fileVoList.length > 0
                  "
                  class="lookImgs"
                  @click="lookBaseImgs(packageDetail.fileVoList)"
                >
                  查看图片
                </div>
              </el-descriptions-item>
              <!-- <el-descriptions-item label="备注"
                >{{ packageDetail.baseInfoVo.remarks }}
              </el-descriptions-item>-->
            </el-descriptions>
            <!-- 收货人信息 -->
            <el-descriptions
              title="收货人信息"
              :column="4"
              border
              size="medium"
            >
              <el-descriptions-item label="收货单位">
                {{ packageDetail.receiveAddressVo.company }}
              </el-descriptions-item>
              <el-descriptions-item label="收货人">
                {{ packageDetail.receiveAddressVo.contacts }}
              </el-descriptions-item>
              <el-descriptions-item label="联系电话">
                {{ packageDetail.receiveAddressVo.phone }}
              </el-descriptions-item>
              <el-descriptions-item label="省份">{{
                packageDetail.receiveAddressVo.provinceName
              }}</el-descriptions-item>
              <el-descriptions-item label="城市">
                {{ packageDetail.receiveAddressVo.cityName }}
              </el-descriptions-item>
              <el-descriptions-item label="区县">
                {{ packageDetail.receiveAddressVo.areaName }}
              </el-descriptions-item>
              <el-descriptions-item label="详细地址">
                {{ packageDetail.receiveAddressVo.address }}
              </el-descriptions-item>
            </el-descriptions>
            <!-- 货物信息 -->
            <div>
              <div class="titles1">货物信息</div>
              <div
                v-for="(item, index) in packageDetail.takeAddressVos"
                :key="index"
              >
                <el-descriptions title :column="4" border size="medium">
                  <el-descriptions-item label="发货单位">
                    {{ item.addressVo.company }}
                  </el-descriptions-item>
                  <el-descriptions-item label="联系人">
                    {{ item.addressVo.contacts }}
                  </el-descriptions-item>
                  <el-descriptions-item label="联系电话">
                    {{ item.addressVo.phone }}
                  </el-descriptions-item>
                  <el-descriptions-item label="提货状态">
                    {{ item.addressVo.areaName }}
                  </el-descriptions-item>
                  <el-descriptions-item label="省份">{{
                    item.addressVo.provinceName
                  }}</el-descriptions-item>
                  <el-descriptions-item label="城市">
                    {{ item.addressVo.cityName }}
                  </el-descriptions-item>
                  <el-descriptions-item label="区县">
                    {{ item.addressVo.areaName }}
                  </el-descriptions-item>
                  <el-descriptions-item label="详细地址">
                    {{ item.addressVo.address }}
                  </el-descriptions-item>
                </el-descriptions>
                <el-table
                  show-summary
                  :data="item.itemVos || []"
                  border
                  stripe
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                  ></el-table-column>
                  <el-table-column
                    prop="goodsNumber"
                    align="center"
                    label="货物编号"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="goodsName"
                    align="center"
                    :show-overflow-tooltip="true"
                    label="货物名称"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="itemCategoryName"
                    align="center"
                    label="品名"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="packageName"
                    align="center"
                    label="包装"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="packageCout"
                    align="center"
                    label="件数"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="grossWeight"
                    align="center"
                    label="毛重"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="netWeight"
                    align="center"
                    label="净重"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="volumeWeight"
                    align="center"
                    label="体积重量"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="billingWeight"
                    align="center"
                    label="计费取值"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="volume"
                    align="center"
                    label="体积/m³"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="itemSpecsVos"
                    align="center"
                    label="规格"
                    min-width="400"
                  >
                    <template slot-scope="scope">
                      <el-table
                        :data="scope.row.itemSpecsVos">
                        <el-table-column
                          prop="length"
                          label="长">
                        </el-table-column>
                        <el-table-column
                          prop="wide"
                          label="宽">
                        </el-table-column>
                        <el-table-column
                          prop="height"
                          label="高">
                        </el-table-column>
                        <el-table-column
                          prop="packageCout"
                          label="件数">
                        </el-table-column>
                      </el-table>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="unitPrice"
                    align="center"
                    label="单价"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <el-table-column
                    prop="freight"
                    align="center"
                    label="运费"
                    :show-overflow-tooltip="true"
                    min-width="100"
                  ></el-table-column>
                  <!-- <el-table-column
                  prop="cccccc"
                  align="center"
                  label="图片"
                  :show-overflow-tooltip="true"
                  min-width="120"
                >
                  <template slot-scope="scoped">
                    <el-button
                      @click="getImgsId(scoped.row.stockPackDescId)"
                      type="text"
                      >查看图片</el-button
                    >
                  </template>
                  </el-table-column>-->
                </el-table>
              </div>
            </div>
            <!-- 签收信息 -->
            <el-descriptions title="签收信息" :column="4" border size="medium">
              <el-descriptions-item label="签收人">
                {{ qiansDatasList.signForName }}
              </el-descriptions-item>
              <el-descriptions-item label="签收时间">
                {{ qiansDatasList.signForTime }}
              </el-descriptions-item>
              <el-descriptions-item label="签收情况">
                {{ qiansDatasList.signForSituationShow }}
              </el-descriptions-item>
              <el-descriptions-item label="签收图片">
                <div
                  v-if="
                    qiansDatasList.fileList &&
                      qiansDatasList.fileList.length > 0
                  "
                  class="lookImgs"
                  @click="lookBaseImgs(qiansDatasList.fileList)"
                >
                  查看图片
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="签收操作人">
                {{ qiansDatasList.createUserName }}
              </el-descriptions-item>
              <el-descriptions-item label="签收操作时间">
                {{ qiansDatasList.createTime }}
              </el-descriptions-item>
              <el-descriptions-item label="备注">
                {{ qiansDatasList.remarks }}
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="second">
            <el-table
              :data="oplogData"
              border
              stripe
              size="small"
              style="width: 100%"
              :height="tableHeigthRight"
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="operatorUserName"
                align="center"
                label="操作人"
                :show-overflow-tooltip="true"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="operatorTime"
                align="center"
                :show-overflow-tooltip="true"
                label="操作时间"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="operatorDeviceShow"
                align="center"
                label="操作设备"
                :show-overflow-tooltip="true"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="operatorName"
                align="center"
                label="操作"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="operatorDescribe"
                align="center"
                label="日志描述"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <!-- <el-table-column
                prop="isShowShow"
                align="center"
                label="前端可见"
                :show-overflow-tooltip="true"
                min-width="80"
              >
              </el-table-column>-->
              <el-table-column
                prop="comment"
                align="center"
                label="备注"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <!-- <el-table-column
                prop="documentStatus"
                align="center"
                label="单据类型"
                :show-overflow-tooltip="true"
                min-width="80"
              >
              </el-table-column>
              <el-table-column
                prop="documentNumber"
                align="center"
                label="单据单号"
                :show-overflow-tooltip="true"
                min-width="140"
              >
              </el-table-column>-->
            </el-table>
            <!-- 分页 -->
            <!-- <paging ref="pags" :pageNum="pageStart_log" :total="pageCount_log" :sizeList="sizeList"
              :size="pageTotal_log" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
            </paging>-->
          </el-tab-pane>
          <el-tab-pane label="财务信息" name="third">
            <!-- 财务应收 -->
            <div class="infoDiv">
              <div class="h3title">运单应收</div>
              <div class="infoDiv">
                <div class="formbox">
                  <el-form
                    :model="CaiWuData"
                    ref="CaiWuDataRef"
                    label-width="100px"
                    class="glo_formBox"
                    disabled
                  >
                    <!-- <el-form-item label="到货区域:" prop="arrivalArea">
                      <el-input
                        v-model="baseInForm.arrivalArea"
                        placeholder="请输入"
                        disabled
                      ></el-input>
                    </el-form-item>-->
                    <!-- <el-form-item label="报价方式:" prop="channelId">
                      <el-select
                        filterable
                        clearable
                        v-model="baseInForm.channelId"
                        placeholder="请选择"
                        @change="changeChannel"
                      >
                        <el-option
                          v-for="item in channelIdList"
                          :key="item.channelId + ''"
                          :label="
                            item.channelName +
                            ' (' +
                            (item.formulaBillingWeightName || '无计费方式') +
                            ')'
                          "
                          :value="item.channelId + ''"
                        ></el-option>
                      </el-select>
                    </el-form-item>-->

                    <!-- <el-form-item
                      label="报价到货区域:"
                      prop="channelArrivalAreaCode"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="baseInForm.channelArrivalAreaCode"
                        placeholder="请选择"
                        @change="changeChannelArrivalArea"
                      >
                        <el-option
                          v-for="item in channelArrivalAreaList"
                          :key="item.channelOfferId + ''"
                          :label="item.offerName"
                          :value="item.channelOfferId + ''"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="计费方式:">
                      <el-select
                        v-model="CaiWuData.formulaBillingWeightId"
                        placeholder="请选择"
                        clearable
                        @change="changeBILLMethode"
                      >
                        <el-option
                          v-for="item in out_going_billing_method_list"
                          :key="item.formulaBillingWeightId + ''"
                          :label="item.formulaBillingWeightName"
                          :value="item.formulaBillingWeightId + ''"
                        ></el-option>
                    </el-select>-->
                    <!-- </el-form-item> -->
                    <el-form-item label="保险费:" prop="insuranceFee">
                      <div class="disFlexs jsInput">
                        <el-input
                          v-model="CaiWuData.insuranceFee"
                          placeholder="请输入"
                          clearable
                          type="number"
                        ></el-input>
                      </div>
                    </el-form-item>
                    <el-form-item label="基本运费:" prop="basicFreight">
                      <div class="disFlexs jsInput">
                        <el-input
                          v-model="CaiWuData.basicFreight"
                          placeholder="请输入"
                          clearable
                          type="number"
                          @input="getTotalFreight()"
                        ></el-input>
                      </div>
                    </el-form-item>
                    <el-form-item label="提货费:" prop="takeFee">
                      <el-input
                        v-model="CaiWuData.takeFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="送货费:" prop="sendFee">
                      <el-input
                        v-model="CaiWuData.sendFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="包装费:" prop="packageFee">
                      <el-input
                        v-model="CaiWuData.packageFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="装卸费:" prop="unLoadFee">
                      <el-input
                        v-model="CaiWuData.unLoadFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="上楼费:" prop="upstairsFee">
                      <el-input
                        v-model="CaiWuData.upstairsFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="等候费:" prop="waitingFee">
                      <el-input
                        v-model="CaiWuData.waitingFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="二次送货费:" prop="againSendFee">
                      <el-input
                        v-model="CaiWuData.againSendFee"
                        placeholder="请输入"
                        clearable
                        type="number"
                        @input="getTotalFreight()"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="其他费用:" prop="allOtherFee">
                      <div class="disFlexs jsInput">
                        <el-input
                          v-model="CaiWuData.allOtherFee"
                          placeholder="请输入"
                          clearable
                          type="number"
                          @input="getTotalFreight()"
                        ></el-input>
                      </div>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="glo_Table" style="margin-bottom: 20px">
                  <el-table
                    ref="ysTable"
                    :data="CaiWuData.itemServiceReqs"
                    show-summary
                    border
                    class="feeAtherTb"
                  >
                    <el-table-column
                      fixed="left"
                      align="center"
                      label="序号"
                      type="index"
                      width="60"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      prop="itemServiceName"
                      label="费项"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      prop="itemCategoryName"
                      label="费项类型"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      prop="amount"
                      label="金额"
                    ></el-table-column>
                    <el-table-column
                      align="center"
                      prop="remarks"
                      label="备注"
                    ></el-table-column>
                  </el-table>
                </div>
                <div class="formbox">
                  <el-form
                    :model="CaiWuData"
                    ref="CaiWuData"
                    label-width="100px"
                    class="glo_formBox"
                    disabled
                  >
                    <el-form-item label="总金额:" prop="totalFreight">
                      <div class="disFlexs jsInput">
                        <el-input
                          v-model="CaiWuData.totalFreight"
                          placeholder="请输入"
                          clearable
                          type="number"
                        ></el-input>
                      </div>
                    </el-form-item>
                    <el-form-item label="结算方式:" prop="totalFreight">
                      <div class="disFlexs jsInput">
                        <el-input
                          v-model="CaiWuData.settlementMethod"
                          placeholder
                          clearable
                        ></el-input>
                      </div>
                    </el-form-item>
                    <!-- <el-form-item
                      label="结算方式:"
                      prop="settlementMethodConfDictId"
                    >
                      <el-select
                        filterable
                        clearable
                        v-model="CaiWuData.settlementMethodConfDictId"
                        placeholder="请选择"
                        @change="changeSettlementMethod"
                      >
                        <el-option
                          v-for="item in settlementMethodList"
                          :key="item.confDictId"
                          :label="item.val"
                          :value="item.confDictId"
                        ></el-option>
                      </el-select>
                    </el-form-item>-->

                    <el-form-item
                      class="textArea"
                      style="width: 100%; margin-right: 0"
                      label="费用备注:"
                      prop="remarks"
                    >
                      <el-input
                        type="textarea"
                        rows="2"
                        v-model="CaiWuData.remarks"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </div>
            <!-- 外发费用 -->
            <div class="infoDiv">
              <div class="h3title">外发费用</div>
              <div class="glo_Table" style="margin-bottom: 20px">
                <el-table
                  show-summary
                  :data="WaybillOutgoingFinance"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    fixed="left"
                    align="center"
                    label="序号"
                    type="index"
                    width="60"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="外发编号"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="outgoingNumber"
                    label="外发承运单号"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="carrierName"
                    label="承运商"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="outgoingRemarks"
                    label="外发备注"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="sendMethod"
                    label="送货方式"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="sendEmployeeName"
                    label="发货人"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="applyReimburseStatus"
                    label="是否申请报销"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="totalAmount"
                    label="实际费用合计"
                  ></el-table-column>
                  <!-- <el-table-column
                    align="center"
                    prop="amount"
                    label="实际费用"
                  ></el-table-column>-->
                  <el-table-column
                    align="center"
                    prop="basicFreight"
                    label="实际运费"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="sendFee"
                    label="实际送货费"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="allOtherFee"
                    label="实际其他费用"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 发车费用 -->
            <div class="infoDiv">
              <div class="h3title">发车费用</div>
              <div class="glo_Table" style="margin-bottom: 20px">
                <el-table
                  show-summary
                  :data="WaybillDispatchFinance"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    fixed="left"
                    align="center"
                    label="序号"
                    type="index"
                    width="60"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="发车批次号"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="itemCategoryName"
                    label="费项类型"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="itemServiceName"
                    label="费项"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="objectStatus"
                    label="结算对象类型"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="objectName"
                    label="结算对象"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="amount"
                    label="金额"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="paymentMethod	"
                    label="付款方式"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="applyReimburseStatus"
                    label="是否申请报销"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="dispatchRemarks"
                    label="发车备注"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="remarks"
                    label="备注"
                  ></el-table-column>
                  <el-table-column fixed="right" prop="cccc" label="图片">
                    <template slot-scope="scope">
                      <div
                        v-if="
                          scope.row.fileList && scope.row.fileList.length > 0
                        "
                        class="lookImgs"
                        @click="lookBaseImgs(scope.row.fileList)"
                      >
                        查看图片
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 财务应付  -->
            <div class="infoDiv">
              <div class="h3title">财务应付</div>
              <div class="glo_Table" style="margin-bottom: 20px">
                <el-table
                  show-summary
                  :data="financeOutInfoReqs"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    fixed="left"
                    align="center"
                    label="序号"
                    type="index"
                    width="60"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="itemServiceName"
                    label="费项"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="amount"
                    label="金额"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="objectName"
                    label="结算对象"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="objectStatus"
                    label="结算对象类型"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="preparerEmployeeName"
                    label="垫付人"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="paymentMethod"
                    label="付款方式"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="isExpenseShow"
                    label="是否申请报销"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="remarks"
                    label="备注"
                  ></el-table-column>
                  <el-table-column fixed="right" prop="cccc" label="图片">
                    <template slot-scope="scope">
                      <div
                        v-if="
                          scope.row.fileVos && scope.row.fileVos.length > 0
                        "
                        class="lookImgs"
                        @click="lookBaseImgs(scope.row.fileVos)"
                      >
                        查看图片
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    prop="cccc"
                    label="操作"
                    v-if="!isPosting"
                  >
                    <template slot-scope="scope">
                      <div class="iconList">
                        <el-button
                          class="tbBtns"
                          @click="EditFeiXian(scope.row, scope.$index)"
                          >编辑</el-button
                        >
                        <el-popconfirm
                          title="确定删除该行货物信息吗"
                          @confirm="delFeiXian2(scope.$index)"
                        >
                          <el-button slot="reference" class="tbBtns"
                            >删除</el-button
                          >
                          <!-- <i slot="reference" class="el-icon-remove iconSize"></i> -->
                        </el-popconfirm>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附 件" name="five">
            <el-table
              :data="BillPackFileListV2"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="createTime"
                align="center"
                label="操作时间"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="operationUserName"
                align="center"
                label="操作人"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="documentStatusShow"
                align="center"
                label="类型"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="fileName"
                align="center"
                label="附件名称"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="comment"
                align="center"
                label="备注"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="fileId"
                align="center"
                label="查看附件"
                min-width="100"
              >
                <template slot-scope="scoped">
                  <el-button type="text" @click="lookImgs(scoped.row.fileId)"
                    >查看图片</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 出入库记录 -->
          <el-tab-pane label="出入库记录" name="six" class="details">
            <el-table
              :data="BillPackInOutStockRecordListV2"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="operationUserName"
                align="center"
                label="操作人"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="operationTime"
                align="center"
                label="操作时间"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="deviceStatusShow"
                align="center"
                label="操作设备"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="operationTypeShow"
                align="center"
                label="操作类型"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="inStorageName"
                align="center"
                label="入库仓库"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="outStorageName"
                align="center"
                label="出库仓库"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="comment"
                align="center"
                label="备注"
                min-width="100"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 客服跟踪 -->
          <el-tab-pane label="客服跟踪" name="seven" class="details">
            <el-table
              :data="kefuDatasList"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                prop="number"
                align="center"
                label="客户跟踪号"
                min-width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="documentNumber"
                align="center"
                label="单据编号"
                min-width="120"
              ></el-table-column>
              <el-table-column
                prop="content"
                align="center"
                label="内容描述"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="remarks"
                align="center"
                label="备注"
                min-width="100"
              ></el-table-column>

              <el-table-column
                prop="documentStatusShow"
                align="center"
                label="单据类型"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="isShowShow"
                align="center"
                label="是否展示"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="operationTime"
                align="center"
                label="发生时间"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="createUserName"
                align="center"
                label="创建人"
                min-width="100"
              ></el-table-column>
              <el-table-column label="查看附件" width="80">
                <template slot-scope="scope">
                  <el-button
                    @click="lookFile(scope.row.recordId)"
                    type="text"
                    size="mini"
                    >查看附件</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 运单轨迹 -->
          <el-tab-pane label="运单轨迹" name="four" class="details">
            <el-table
              :data="BillPackExpressListV2"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <!-- <section>{{ item.happenTime }}</section> -->
              <el-table-column
                prop="createTime"
                align="center"
                label="操作时间"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="happenTime"
                align="center"
                label="发生时间"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="content"
                align="center"
                label="轨迹"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
            </el-table>
          </el-tab-pane>
          <!-- 签收信息 -->
          <!-- <el-tab-pane label="签收信息" name="eigth" class="details">
            <el-table
              :data="qiansDatasList"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                prop="signForName"
                align="center"
                label="签收人"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="signForTime"
                align="center"
                label="签收时间"
                min-width="100"
              ></el-table-column>
              <el-table-column
                prop="remarks"
                align="center"
                label="备注"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
              <el-table-column
                prop="remarks"
                align="center"
                label="备注"
                :show-overflow-tooltip="true"
                min-width="160"
              ></el-table-column>
            </el-table>
          </el-tab-pane>-->
        </el-tabs>
      </div>
    </div>
    <!-- 会员管理查询弹出层 -->
    <el-dialog
      title="会员管理"
      :visible.sync="isDT"
      width="50%"
      :close-on-click-modal="false"
      @close="resetData('vf')"
    >
      <div class="newForm">
        <div class="formS">
          <el-form
            ref="vf"
            size="mini"
            :model="vf"
            :rules="vfr"
            label-width="80px"
          >
            <el-row>
              <el-col :span="19" style="display: flex">
                <div class="queryItem1">
                  <el-form-item label="会员号:" prop="memberId">
                    <el-input v-model="vf.memberId"></el-input>
                  </el-form-item>
                </div>
                <div class="queryItem1">
                  <el-form-item label="会员名称:" prop="nickname">
                    <el-input v-model="vf.nickname"></el-input>
                  </el-form-item>
                </div>
                <!-- <div class="queryItem1">
                  <el-form-item label="仓库:" prop="memberId">
                    <el-select
                      v-model="vf.memberId"
                      placeholder="请选择活动区域"
                    >
                      <el-option label="区域一" value="shanghai"></el-option>
                      <el-option label="区域二" value="beijing"></el-option>
                    </el-select>
                  </el-form-item>
                </div>-->
              </el-col>
              <el-col :span="1">
                <el-form-item label-width="10px">
                  <el-button type="warning" @click="cxEdit">查 询</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="tableBox">
          <el-table
            :data="ut"
            size="mini"
            max-height="400px"
            border
            style="width: 100%"
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="50"
            ></el-table-column>
            <el-table-column
              prop="memberId"
              label="会员号"
              align="center"
              min-width="100"
            ></el-table-column>
            <el-table-column
              prop="nickName"
              label="会员名称"
              align="center"
              min-width="120"
            ></el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              align="center"
              min-width="100"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="color: #ef7c1b"
                  size="mini"
                  @click="xz(scope.row)"
                  >选 择</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页组件 -->
          <paging
            ref="pags"
            :pageNum="pageStart_u"
            :total="pageCount_u"
            :sizeList="sizeList"
            :size="pageTotal_u"
            @handleSizeChange="psc_u"
            @handleCurrentChange="pcc_u"
          ></paging>
        </div>
      </div>
    </el-dialog>
    <!-- 查询轨迹 -->
    <el-dialog
      title="查询轨迹"
      :visible.sync="isDT_query"
      width="56%"
      :close-on-click-modal="false"
      @close="resetData('eidtQuery')"
    >
      <div class="queryBox">
        <el-form
          ref="eidtQuery"
          size="mini"
          :inline="true"
          :model="eidtQuery"
          label-width="80px"
        >
          <el-form-item label="快递单号">
            <el-input v-model="eidtQuery.courierNumber" clearable></el-input>
          </el-form-item>

          <el-form-item label="快递公司编码">
            <el-select v-model="eidtQuery.expressCode" clearable filterable>
              <el-option
                v-for="item in kuaidiList"
                :key="item.expressNumber"
                :label="item.expressName"
                :value="item.expressNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="eidtQuery.phone" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="eidtQuerySubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="showBox">
        <div class="countryGrounp">
          <div class="countryItem">{{ formQuery.areaCountryName }}</div>
          <div class="number">{{ formQuery.courierNumber }}</div>
        </div>
      </div>
      <div class="contentBox">
        <el-table
          :data="formQuery.data"
          size="mini"
          max-height="500"
          stripe
          highlight-current-row
          border
          style="width: 100%"
        >
          <el-table-column
            align="center"
            prop="time"
            label="时间"
            min-width="30%"
          ></el-table-column>
          <el-table-column
            prop="context"
            align="center"
            :show-overflow-tooltip="true"
            label="轨迹"
            min-width="70%"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!-- 客户加收弹窗 -->
    <el-dialog
      :title="titleH"
      :visible.sync="isDT_addC"
      width="50%"
      center
      :close-on-click-modal="false"
      @close="resetData('customerForm')"
    >
      <div class="newForm customerForm">
        <el-form
          ref="customerForm"
          :model="customerForm"
          :rules="customerRules"
          label-width="100px"
        >
          <!-- <div class="queryItem1">
            <el-form-item label="加收编号:">
              <el-input
                v-model="customerForm.courierNumber"
                readonly
                placeholder="添加后自动生成"
              ></el-input>
            </el-form-item>
          </div>-->
          <template v-if="isCustomer">
            <div class="queryItem1" @click="changeVip">
              <el-form-item label="会员号:" prop="userName">
                <el-input
                  v-model="customerForm.userName"
                  readonly
                  placeholder="请选择"
                ></el-input>
              </el-form-item>
            </div>
          </template>
          <template v-else>
            <div class="queryItem1">
              <el-form-item label="渠道代理:" prop="customerAgentId">
                <el-select
                  v-model="customerForm.customerAgentId"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in agentArr"
                    :key="item.customerAgentId"
                    :label="item.agentName"
                    :value="item.customerAgentId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </template>
          <div class="queryItem1">
            <el-form-item label="来源单据:" prop="financeDocumentstatusId">
              <el-select
                v-model="customerForm.financeDocumentstatusId"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in lyArr"
                  :key="item.financeDocumentstatusId"
                  :label="item.documentStatusName"
                  :value="item.financeDocumentstatusId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="queryItem1">
            <el-form-item label="来源单号:" prop="documentNumber">
              <el-input
                v-model="customerForm.documentNumber"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <!--<div class="queryItem1">-->
          <!--<el-form-item label="会员名称:" prop="nickname">-->
          <!--<el-input v-model="customerForm.nickname"></el-input>-->
          <!--</el-form-item>-->
          <!--</div>-->
          <div class="queryItem1">
            <el-form-item label="加收项目:" prop="itemServiceId">
              <el-select
                v-model="customerForm.itemServiceId"
                @change="changeServe"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in serveArr"
                  :key="item.itemServiceId"
                  :label="item.title"
                  :value="item.itemServiceId"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="queryItem1">
            <el-form-item label="金额:" prop="settlementAmount">
              <el-input v-model="customerForm.settlementAmount"></el-input>
            </el-form-item>
          </div>
          <div class="queryItem1">
            <el-form-item label="仓库:">
              <el-select
                class="input"
                v-model="customerForm.storageId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in storageList"
                  :key="item.storageName"
                  :label="item.storageName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="queryItem1">
            <el-form-item label="加收备注:" prop="comment">
              <el-input v-model="customerForm.comment"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="addCustomerM"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 大图预览 -->
    <el-dialog
      title="图片预览"
      :visible.sync="bigImgsShow"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <div class>
        <div v-for="(item, index) in srcList" :key="index">
          <el-image
            style="width: 180px; height: 180px; margin: 10px"
            :src="item"
            :preview-src-list="srcList"
          ></el-image>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="bigImgsShow = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <!-- 上传附件 -->
    <el-dialog
      title="上传附件"
      :visible.sync="UpLoadfileShow"
      @close="closeDia"
      width="50%"
      center
      :close-on-click-modal="false"
    >
      <div class>
        <el-form
          class="upLoadForm"
          ref="forms"
          :model="formFileData"
          label-width="100px"
        >
          <el-form-item label="运单号" style="width: 49%">
            <el-select
              class="input"
              v-model="formFileData.waybillNumber"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in expressData"
                :key="index"
                :label="item.waybillNumber"
                :value="item.waybillNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="附件类型" style="width: 49%">
            <el-select
              class="input"
              v-model="formFileData.documentStatus"
              filterable
              clearable
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="(item, index) in documentStatusList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否展示" style="width: 98%">
            <el-select
              class="input"
              v-model="formFileData.isShow"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in isShowList"
                :key="index"
                :label="item.showName"
                :value="item.statusVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" style="width: 98%">
            <el-input
              placeholder="请输入"
              type="textarea"
              v-model="formFileData.comment"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传附件">
            <el-upload
              class="upload-demo"
              :http-request="uploadSectionFile"
              :before-upload="handleBeforeUpload"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :file-list="fileLists"
              drag
              :action="upLoadUrl"
              multiple
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                只能上传jpg/png/jpeg文件，且不超过5M
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="warning" size="mini" @click="confirmUpload"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showFilse" width="50%">
      <el-image
        style="width: 600px; height: 600px"
        :src="fileurls"
        :preview-src-list="srcList"
      ></el-image>
    </el-dialog>

    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :waybillNumber="waybillNumber"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <el-dialog
      title="查看图片"
      :visible.sync="showBigImgs"
      append-to-body
      width="60%"
      center
    >
      <div class="wtl_displayFlex">
        <div class="imgItems" v-for="(item, index) in bigImgs" :key="index">
          <el-image
            style="width: 200px; height: 200px"
            :src="item.fileUrl"
            :preview-src-list="bigImgUrls"
          ></el-image>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showBigImgs = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { this.$API } from "@/assets/js/api";
// import this.$TOOLS from "@/assets/js/tool";
import paging from "@/components/pagings.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";
import queryBtns from "@/components/queryBtns.vue";
import multitime from "@/components/multiTime.vue";
export default {
  inject: ["reload"],
  components: { paging, addCustomerTarck, queryBtns, multitime },
  data() {
    return {
      upLoadUrl: this.$COMMON.uploadUrl,
      fileSize: 5, //文件最大5M
      fileLists: [],
      srcList: [],
      fileType: ["png", "jpg", "jpeg"],
      showFilse: false,
      fileurls: "",
      queryData: {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        onwayStatus: "",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        pageStart: 1,
        pageTotal: this.$COMMON.pageTotals,
        startTime: "",
        endTime: "",
      },
      channelList: [], //  渠道代理下拉列表
      storageList: [], //  仓库下拉列表
      kuaidiList: [], //快递公司下拉
      packageStatusList: [], //  包裹状态下拉列表
      testStatusList: [], //  验货状态下拉列表
      rejectionStatusList: [], //  拒签状态下拉列表
      expressData: [], //  快递单号表格
      tableHeigth: "75vh", //  表格高度
      tableHeigthRight: "75vh", //  右边高度
      tableHeigth_log: 0,
      pageStart: 1, //  分页配置
      pageTotal: this.$COMMON.pageTotals,
      pageCount: 0,
      sizeList: [10, 20, 50, 100, 500],
      //    会员选择
      isDT: false,
      vf: {},
      vfr: {},
      ut: [],
      pageStart_u: 1, //  分页配置
      pageTotal_u: 50,
      pageCount_u: 0,
      //    查询轨迹
      isDT_query: false,
      eidtQuery: {
        courierNumber: "",
        expressCode: "",
        phone: "",
      }, //   查询表单
      formQuery: {},
      //    tab标签页
      activeName: "first",
      packageDetail: {
        baseInfoVo: {
          waybillNumber: "",
          memberId: "",
          memberName: "",
          currentStorageName: "",
          transportName: "",
          channelName: "",
          channeAgentlName: "",
          channelNumber: "",
          shiftNumber: "",
          packageCount: "",
          packSureCount: "",
          totalWeight: "",
          dataVolume: "",
          totalVolume: "",
          billStorepackComment: "",
        },
        receiveAddressVo: {
          address: "",
          areaCountryName: "",
          areaName: "",
          companyName: "",
          fullName: "",
          phone: "",
          postalCode: "",
          provinceName: "",
          tel: "",
          userAddressId: "",
        },
        descPackageVo: [],
      },
      oplogData: [], //  操作日志表格数据

      packageDetailsData: [], //  包裹明细表格数据
      BillPackExpressListV2: [], //  轨迹
      BillPackFileListV2: [], //  附件列表
      BillPackInOutStockRecordListV2: [], //  附件列表
      kefuDatasList: [], //客服跟踪
      qiansDatasList: {}, //
      pageStart_log: 1,
      pageTotal_log: 50,
      pageCount_log: 0,
      waybillSplitId: "",
      //    客户加收
      isDT_addC: false,
      customerForm: {
        settlementAmount: "",
        financeDocumentstatusId: "",
        customerAgentId: "",
        itemServiceId: "",
        comment: "",
        documentNumber: "",
        storageId: "",
        serviceName: "",
      },
      customerRules: {
        settlementAmount: [{ required: true, message: " ", trigger: "blur" }],
        userName: [{ required: true, message: " ", trigger: "blur" }],
        financeDocumentstatusId: [
          { required: true, message: " ", trigger: "change" },
        ],
        customerAgentId: [{ required: true, message: " ", trigger: "change" }],
      },
      lyArr: [],
      serveArr: [],
      isCustomer: true,
      agentArr: [],
      titleH: "",
      uids: "",

      startTime_a: "",
      endTime_a: "",
      timeType: "0", //默认的时间类型
      timeTypes: [
        //  时间类型
        {
          value: "0",
          label: "创建日期",
        },
        {
          value: "1",
          label: "业务日期",
        },
      ],
      packageStatusArr: [],
      documentStatusList: [
        {
          dictStatusNumber:
            "file_all_v2.document_status.bill_tms_waybill_v3:document_status",
          languageCode: "zh-CN",
          showName: "tms运单附件",
          sort: 375,
          statusVal: "bill_tms_waybill_v3:document_status",
        },
      ],
      isShowList: [
        {
          showName: "展示",
          statusVal: "1",
        },
        {
          showName: "不展示",
          statusVal: "0",
        },
      ],
      yunshuList: [],
      srcList: [], //打包明细图片列表
      bigImgsShow: false,

      // 客服跟踪的组件
      showDia1: false,
      documentNumbers: "",
      documentStatus: "",

      UpLoadfileShow: false, //上传附件

      formFileData: {
        isShow: "1",
        waybillNumber: "",
        comment: "",
        fileIds: [],
        fileName: "",
        documentStatus: "bill_tms_waybill_v3:document_status",
      },
      pageType: "",

      showBigImgs: false, //查看图片
      bigImgs: [],
      bigImgUrls: [],
      CustomerLists: [],
      fileNameLists: [], //修改时的文件列表

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件

      waybillStatusList: [], //运单状态
      OnwayStatusList: [], //在途状态
      OutgoingStatusList: [], //外发状态
      storageList: [], //网点列表
      CarrierLists: [], //承运商列表

      isPosting: true, //不展示计算按钮
      amountIsAble: true,
      // 财务应收
      CaiWuData: {
        agentAmount: "",
        allOtherFee: "",
        basicFreight: "",
        billingAmount: "",
        goodsDeductedAmoun: "",
        insuranceFee: "",
        invoiceTaxPoint: "",
        isInvoice: "0",
        monthlyAmount: "",
        receivedAmount: "",
        remarks: "",
        rnorderAmount: "",
        sendFee: "",
        senderAmount: "",
        settlementMethodConfDictId: "",
        takeFee: "",
        taxes: "",
        totalFreight: "",
        unLoadFee: "",
        itemServiceReqs: [],
      },
      financeOutInfoReqs: [], //财务应付
      WaybillDispatchFinance: [], //发车单财务信息
      WaybillOutgoingFinance: [], //外发单单财务信息
      settlementMethodList: [], //结算方式
      yesOrNoList: [
        {
          name: "是",
          val: "1",
        },
        {
          name: "否",
          val: "0",
        },
      ],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],
      waybillNumber: "",
      orderNumber: "",
    };
  },
  created() {
    this.queryData.startTime = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.queryData.endTime = this.$TOOLS.getCurrentDate(); //今天的时间;;
  },
  mounted() {
    this.getCustomerList(); //  获取客户列表
    this.getWaybillStatus(); //
    this.getOnwayStatus(); //
    this.getOutgoingStatus(); //
    this.getCarrierList(); // 获取承运商列表
    this.getObjectUserDownList("storage"); // 网点列表
    //文件来源单据类型
    // this.$TOOLS.getStatusValList("file_all_v2.document_status").then((res) => {
    //   this.documentStatusList = res || []; //  获取包裹状态
    // });
  },
  activated() {
    let packid = this.$route.query.waybillSplitId || "";
    this.pageType = this.$route.query.pageType || "";

    if (packid) {
      this.waybillSplitId = packid;
      this.queryData.waybillNumber = this.$route.query.waybillNumber;
      this.waybillNumber = this.$route.query.waybillNumber;
      this.orderNumber = this.$route.query.orderNumber;
      this.reloadData(); // 获取主要数据的几个方法
      this.getExpressData(); //  获取左边列表表格
    }
  },
  watch: {},
  methods: {
    // 根据对象类型获取对象的下拉列表
    getObjectUserDownList(key) {
      this.$API
        .wtl_getObjectUserDownList({
          key: key,
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          if (key == "employee") {
            this.EmployeeList = arrs;
          }
          if (key == "dept") {
            this.depList = arrs;
          }
          if (key == "storage") {
            this.storageList = arrs;
          }
        });
    },
    // 选择承运商
    changeCarrier(e) {
      if (e) {
        this.CarrierLists.forEach((item) => {
          if (item.carrierName == e) {
            this.queryData.outboundCarrierId = item.carrierId;
          }
        });
      } else {
        this.queryData.outboundCarrierId = "";
        this.getCarrierList();
      }
      this.queryBtn_ok();
    },
    // 获取承运商列表
    getCarrierList(carrierName) {
      this.$API
        .CarrierList({
          pageStart: 1,
          pageTotal: 200,
          carrierName: carrierName || "",
        })
        .then((res) => {
          this.CarrierLists = res.data.result.data || [];
        });
    },
    // 获取运单状态
    getWaybillStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.waybill_status")
        .then((res) => {
          this.waybillStatusList = res || [];
        });
    },
    // 获取在途状态
    getOnwayStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.onway_status")
        .then((res) => {
          this.OnwayStatusList = res || [];
        });
    },
    // 外发状态
    getOutgoingStatus() {
      this.$TOOLS
        .getStatusValList("bill_tms_waybill_split_v3.outgoing_status")
        .then((res) => {
          this.OutgoingStatusList = res || [];
        });
    },
    // 获取运单附件
    getWaybillFiles(waybillSplitId) {
      this.$API
        .wtl_getWaybillFiles({ waybillSplitId: waybillSplitId })
        .then((res) => {
          console.log(res, "运单附件");
        });
    },
    // 根据字典类型获取字典值下拉列表
    getConfDictValDownList(dictType) {
      this.$API
        .wtl_getConfDictValDownList({ dictType: dictType })
        .then((res) => {
          let arrs = res.data.result || [];
          if (dictType == "package_name") {
            // 包装
            this.packageNameList = arrs;
            this.goodsInfoList[0].itemReqs[0].packageNameList = arrs;
          }
          if (dictType == "waybill_type") {
            // 货物类型
            this.waybillTypeList = arrs;
          }
          if (dictType == "rn_order_require") {
            // 回单类型
            this.rnrderRequireList = arrs;
          }
          if (dictType == "send_method") {
            // 获取送货方式列表
            this.sendMethodList = arrs;
          }
          if (dictType == "receive_method") {
            // 获取收货方式列表
            this.ReceivingMethodList = arrs;
          }
          if (dictType == "transport_method") {
            // 获取运输方式列表
            this.transportModeList = arrs;
          }
          if (dictType == "object_status") {
            // 获取结算对象类型
            this.objectStatusList = arrs || [];

            //
          }
          if (dictType == "settlement_method") {
            // 获取付款方式
            this.settlementMethodList = arrs;
          }
        });
    },

    // 获取客户列表
    getCustomerList(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: "customer",
          name: name,
          number: "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerLists = res.data.result.data || [];
        });
    },
    // 选择客户触发
    changeCustomerNumber(e) {
      if (!e) {
        this.getCustomerList();
      }
      this.queryBtn_ok();
    },
    // 查看附件
    lookFile(id) {
      this.$API.getBillKfTrackRecordFileV2({ recordId: id }).then((res) => {
        let result = res.data.result || [];
        if (result.length == 0) {
          this.$message.warning("当前跟踪单没有相关的文件");
        } else {
          this.showBigImgs = true;
          this.bigImgs = result;
          this.bigImgUrls = result.map((item) => {
            return item.fileUrl;
          });
        }
      });
    },

    handleRemove(file, fileList) {
      this.fileLists = fileList || [];
    },
    handlePictureCardPreview(file) {
      console.log(file);
      console.log(this.fileLists);
      this.showFilse = true;
      this.fileurls = file.url;
      this.srcList = this.fileLists.map((item) => {
        return item.url;
      });
    },
    // 上传接口
    uploadSectionFile(param) {
      const file = param.file;
      const fileName = file.name;
      const form = new FormData(); //  根据后台需求数据格式
      form.append("file", file); //  文件对象
      form.append("fileName", fileName); //  本例子主要要在请求时添加特定属性，所以要用自己方法覆盖默认的action

      let signArr = {
        fileName: fileName,
      };
      let sign = this.$TOOLS.getSign(signArr);
      form.append("sign", sign);
      // return;
      this.$API.uploadFile(form).then((res) => {
        if (res.data.status === "success") {
          //   this.fileNameList.push(res.data.result.fileName);
          let obj = {
            name: res.data.result.fileName,
            url: res.data.result.url,
          };
          this.fileLists.push(obj);
          console.log("fileLists", this.fileLists);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      console.log(file);
      console.log(this.fileType);
      // 校检文件类型
      if (this.fileType && file) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        let isTypeOk = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        console.log(file);
        console.log(isTypeOk);
        if (!isTypeOk && file) {
          this.$message.error(
            `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
          );
          return false;
        }
      }
      // 校检文件大小
      if (this.fileSize && file) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    // 确定上传附件
    confirmUpload() {
      let fileIds = [];
      this.fileLists.forEach((item) => {
        fileIds.push(item.name);
      });
      let param = {
        documentNumber: this.formFileData.waybillNumber,
        comment: this.formFileData.comment,
        documentStatus: this.formFileData.documentStatus,
        fileIds: fileIds,
        isShow: this.formFileData.isShow || 0,
      };
      param.sign = this.$TOOLS.getSign(param);
      this.$API.wtl_uploadWaybillFile(param).then((res) => {
        this.$message.success(res.data.message || "新建成功");
        this.UpLoadfileShow = false;
      });
    },

    //客服跟踪 (跳转新建问题)
    kehugenzong() {
      // this.$router.push({
      //   path: "/exceptionhandling/NewQuestion",
      // });
      // if (this.packageDetail.baseInfoVo.waybillNumber) {
      //   this.documentNumbers = this.packageDetail.baseInfoVo.waybillNumber;
      // }
      this.waybillNumber = this.waybillNumber;
      this.documentNumbers = this.orderNumber;
      this.documentStatus = "bill_tms_waybill_split_v3:document_status"; //tms运单单据
      this.showDia1 = true;
    },
    uploadFIle() {
      this.UpLoadfileShow = true;
      this.formFileData.waybillNumber = this.waybillNumber;
    },
    closeDia() {
      this.fileLists = [];
      this.formFileData = {
        isShow: "1",
        waybillNumber: "",
        comment: "",
        fileIds: [],
        fileName: "",
        documentStatus: "bill_tms_waybill_v3:document_status",
      };
    },
    // 提交新建
    confirmAdd(formName) {
      this.showDia1 = false;
      // this.getData();
    },
    // 关闭重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = "";
    },
    // 数组
    lookImgsArr(imgs) {
      console.log(imgs);
    },
    //单图
    lookImgs(id) {
      if (id) {
        this.$API.wtl_getFileUrl({ fileName: id }).then((res) => {
          let filse = res.data.result || {};
          if (filse.url) {
            let arrs = [];
            arrs.push(filse.url);
            this.srcList = arrs;
            this.bigImgsShow = true;
          } else {
            this.$message.warning("打开失败,没有检测到图片地址");
          }
        });
      } else {
        this.$message.warning("打开失败,没有检测到图片地址");
      }
    },
    // 运单图片
    lookBaseImgs(arr) {
      console.log(arr);
      this.srcList = arr.map((item) => {
        return item.url || item.fileUrl;
      });
      this.bigImgsShow = true;
    },
    // 打包明细查看图片
    getImgsId(id) {
      console.log(id);
      this.$API
        .getStorepackDescFileV2({ stockPackDescId: id })
        .then((res) => {
          let imgs = res.data.result || [];
          let arrs = [];
          if (imgs.length > 0 && imgs[0].fileUrl) {
            imgs.forEach((element) => {
              arrs.push(element.fileUrl);
            });
            this.srcList = arrs;
            this.bigImgsShow = true;
          } else {
            this.$message.warning("该包裹没有打包图片");
          }
        })
        .catch(() => {});
    },

    // 获取主要数据
    reloadData() {
      let val = this.activeName;
      switch (val) {
        case "first":
          this.getPackageDetails(); //详情
          this.qianShou(); //签收信息
          break;
        case "second":
          this.getPackageLogOperates(); //操作日志
          break;
        case "third":
          this.myGetPackageFinanceInDetail(); //财务应收
          this.getConfDictValDownList("settlement_method");
          this.getWaybillDispatchFinance();
          this.getWaybillOutgoingFinance();
          break;
        case "four":
          this.getBillPackExpressListV2(); //运单运输轨迹
          break;
        case "five":
          this.getBillPackFileListV2(); //附件
          break;
        case "six":
          this.getBillPackInOutStockRecordListV2(); //出入库记录
          break;
        case "seven":
          this.kefuDatas(); //客服跟踪
          break;
      }
    },
    clickActiveName(e) {
      let val = e.name;
      switch (val) {
        case "first":
          this.getPackageDetails(); //详情
          this.qianShou(); //签收信息
          break;
        case "second":
          this.getPackageLogOperates(); //操作日志
          break;
        case "third":
          this.myGetPackageFinanceInDetail(); //财务信息
          this.getConfDictValDownList("settlement_method");
          this.getWaybillDispatchFinance(); //获取运单发车批次应付财务信息
          this.getWaybillOutgoingFinance(); //外发财务信息
          break;
        case "four":
          this.getBillPackExpressListV2(); //运单运输轨迹
          break;
        case "five":
          this.getBillPackFileListV2(); //附件
          break;
        case "six":
          this.getBillPackInOutStockRecordListV2(); //出入库记录
          break;
        case "seven":
          this.kefuDatas(); //客服跟踪
          break;
      }
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 获取左边运单号列表
    getExpressData() {
      let startBusinessTime = "";
      let endBusinessTime = "";
      let startCreateTime = "";
      let endCreateTime = "";

      let startTime = this.startTime_a ? this.startTime_a + " 00:00:00" : "";
      let endTime = this.endTime_a ? this.endTime_a + " 23:59:59" : "";

      if (this.timeType == "0") {
        startCreateTime = startTime;
        endCreateTime = endTime;
      }
      if (this.timeType == "1") {
        startBusinessTime = startTime;
        endBusinessTime = endTime;
      }

      // let startTime = this.queryData.startTime;
      // let endTime = this.queryData.endTime;
      // if (startTime) {
      //   startTime = startTime + " 00:00:00";
      // }
      // if (endTime) {
      //   endTime = endTime + " 23:59:59";
      // }
      // let startBusinessTime = "";
      // let endBusinessTime = "";
      // let startCreateTime = "";
      // let endCreateTime = "";
      // if (this.timeType == "1") {
      //   // 业务日期
      //   startBusinessTime = startTime;
      //   endBusinessTime = endTime;
      // } else if (this.timeType == "0") {
      //   // 创建时间
      //   startCreateTime = startTime;
      //   endCreateTime = endTime;
      // }

      let param = {
        currentDeptId: this.queryData.currentDeptId,
        customerNumber: this.queryData.customerNumber,
        customereOrderNumber: this.queryData.customereOrderNumber,
        endBusinessTime: endBusinessTime,
        endCreateTime: endCreateTime,
        onwayStatus: this.queryData.onwayStatus,
        outboundCarrierId: this.queryData.outboundCarrierId,
        outgoingStatus: this.queryData.outgoingStatus,
        startBusinessTime: startBusinessTime,
        startCreateTime: startCreateTime,
        waybillNumber: this.queryData.waybillNumber,
        waybillStatus: this.queryData.waybillStatus,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getWaybillNumberList(param).then((res) => {
        if (res.data.status === "success") {
          this.expressData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });

          // 没有id的时候
          if (!this.waybillSplitId) {
            if (this.expressData.length == 0) {
              return false;
            }
            this.waybillSplitId = this.expressData[0].waybillSplitId;
            this.orderNumber = this.expressData[0].orderNumber;
            this.reloadData();
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getPackageDetails() {
      //  获取包裹详情
      this.$API
        .wtl_getWaybillDetail({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          this.packageDetail = res.data.result;
          // this.waybillNumber = res.data.result.baseInfoVo.waybillNumber || "";
        });
    },
    getPackageLogOperates() {
      //  获取操作日志
      this.$API
        .wtl_getWaybillOperateLog({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          this.oplogData = res.data.result || [];
          // this.pageCount_log = res.data.result.pageCount;
        });
    },

    myGetPackageFinanceInDetail() {
      //  获取运单财务信息
      this.$API
        .wtl_getWaybillFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          this.CaiWuData = datas.financeInInfoVo;
          // this.isPosting = datas.financeInInfoVo.isPosting == 1 ? true : false;
          this.CaiWuData.itemServiceReqs = datas.financeInInfoVo.itemServiceVos;
          this.CaiWuData.isInvoice = datas.financeInInfoVo.isInvoice + "";

          // 应付
          this.financeOutInfoReqs = datas.financeOutinfoVos;
        });
    },

    //  获取运单发车批次应付财务信息
    getWaybillDispatchFinance() {
      this.$API
        .getWaybillDispatchFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || "";
          this.WaybillDispatchFinance = datas.financeOutVos || [];
        });
    },
    //  获取外发应付财务信息
    getWaybillOutgoingFinance() {
      this.$API
        .getWaybillOutgoingFinance({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          let datas = res.data.result || [];
          this.WaybillOutgoingFinance = datas || [];
        });
    },
    // 运单运输轨迹
    getBillPackExpressListV2() {
      this.$API
        .wtl_getWaybillTrack({
          waybillNumber: this.orderNumber,
        })
        .then((res) => {
          this.BillPackExpressListV2 = res.data.result || [];
        });
    },
    //  附件列表
    getBillPackFileListV2() {
      this.$API
        .wtl_getWaybillFiles({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          this.BillPackFileListV2 = res.data.result || [];
        });
    },
    //  出入库记录
    getBillPackInOutStockRecordListV2() {
      this.$API
        .wtl_getWaybillStockRecord({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          this.BillPackInOutStockRecordListV2 = res.data.result || [];
        });
    },
    //  客服跟踪
    kefuDatas() {
      let formData = {
        documentNumber: this.orderNumber,
        documentStatus:
          this.documentStatus || "bill_tms_waybill_split_v3:document_status",
        // documentStatus: "bill_pack_v1:document_status",
        // content: this.queryData.content,
        // isShow: this.queryData.isShow,
        // endCreateTime: endCreateTime,
        // startCreateTime: startCreateTime,
        // endOperationTime: endOperationTime,
        // startOperationTime: startOperationTime,
        // pageStart: this.pageNum,
        // pageTotal: this.size,
      };

      this.$API.getBillKfTrackRecordListV2(formData).then((res) => {
        if (res.data.status == "success") {
          this.kefuDatasList = res.data.result.data || [];

          // this.fetTableHeight();
        }
      });
    },
    //  签收信息
    qianShou() {
      let formData = {
        waybillSplitId: this.waybillSplitId,
      };

      this.$API.getWaybillSignforInfo(formData).then((res) => {
        if (res.data.status == "success") {
          this.qiansDatasList = res.data.result?.[0] || [];

          // this.fetTableHeight();
        }
      });
    },
    getPackageItems() {
      //  获取包裹明细
      this.$API
        .packageItems({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          if (res.data.status === "success") {
            this.packageDetailsData = res.data.result;
          } else {
            this.$message.error(`${res.data.message}--包裹明细`);
          }
        });
    },

    queryForKD100() {
      //  查询快递轨迹
      let param = {
        courierNumber: this.eidtQuery.courierNumber,
        expressCode: this.eidtQuery.expressCode,
        phone: this.eidtQuery.phone || "",
      };
      param.sign = this.$TOOLS.getSign(param);
      this.$API.expressQueryForKD100(param).then((res) => {
        if (res.data.status === "success") {
          this.formQuery = res.data.result;
        } else {
          this.$message.error(`${res.data.message}--查询快递轨迹`);
        }
      });
    },
    eidtQuerySubmit() {
      this.queryForKD100();
    },

    clerBtns() {
      //  重置按钮

      this.queryData = {
        currentDeptId: "",
        customerNumber: "",
        customereOrderNumber: "",
        endBusinessTime: "",
        endCreateTime: "",
        onwayStatus: "",
        outboundCarrierId: "",
        outgoingStatus: "",
        startBusinessTime: "",
        startCreateTime: "",
        waybillNumber: "",
        waybillStatus: "",
        pageStart: 1,
        pageTotal: this.$COMMON.pageTotals,
        startTime: "",
        endTime: "",
      };
      this.queryBtn_ok();
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 查询按钮
    queryBtn_ok() {
      this.pageStart = 1;
      this.getExpressData(); //  获取左边列表表格
    },
    psc(val) {
      //  表格分页-当前页面总条数
      this.pageTotal = val;
      this.getExpressData(); //  获取左边列表表格
    },
    pcc(val) {
      //  表格分页-页码
      this.pageStart = val;
      this.getExpressData(); //  获取左边列表表格
    },
    dblclick(row) {
      console.log(row);
      this.waybillSplitId = row.waybillSplitId;
      this.waybillNumber = row.waybillNumber;
      this.orderNumber = row.orderNumber;
      this.reloadData();
    },

    //   -------- 编辑会员 -----------
    changeVip() {
      //  选择会员名称
      this.getVipList();
      this.isDT = true;
    },

    getVipList() {
      //  获取会员列表
      this.vf.pageStart = this.pageStart_u;
      this.vf.pageTotal = this.pageTotal_u;
      this.$API.getMemberList(this.vf).then((res) => {
        if (res.data.status === "success") {
          this.ut = res.data.result.data;
          this.pageCount_u = res.data.result.pageCount || 0;
        }
      });
    },

    xz(data) {
      //  会员表格选择事件
      if (this.isDT_addC) {
        this.customerForm.userId = data.id;
        this.customerForm.userName = data.memberId;
      } else {
        this.queryData.memberId = data.memberId;
        this.uids = data.id;
      }
      this.isDT = false;
    },
    cxEdit() {
      //  查询按钮
      this.pageStart_u = 1;
      this.getVipList();
    },
    psc_u(val) {
      //  分页事件
      this.pageTotal_u = val;
      this.getVipList();
    },
    pcc_u(val) {
      //  分页事件
      this.pageStart_u = val;
      this.getVipList();
    },
    handleSizeChange(val) {
      this.pageTotal_log = val;
      this.getPackageLogOperates();
    },
    handleCurrentChange(val) {
      this.pageTotal_log = val;
      this.getPackageLogOperates();
    },
    handleClose(num) {
      //  会员弹出框关闭前回调事件
      this.resetData("vf");
    },
    resetData(formName) {
      this.$refs[formName].resetFields();
    },

    //客户追踪
    NewQuestion() {
      this.$router.push("/exceptionhandling/NewQuestion?pageType=" + "track");
    },

    getLyArr() {
      //  获取来源单据
      this.$API.financeDocumentstatusChooseList().then((res) => {
        this.lyArr = res.data.result;
      });
    },
    getServeArr() {
      //  获取服务项
      this.$API
        .itemServiceListAll({ serviceStatus: "shou:direction_status" })
        .then((res) => {
          this.serveArr = res.data.result;
        });
    },

    changeServe(val) {
      //  选择服务项的自动填写事件
      let index = this.serveArr.findIndex((v) => v.itemServiceId === val);
      this.customerForm.settlementAmount = this.serveArr[index].unitPrice;
      this.customerForm.serviceName = this.serveArr[index].title;
    },

    addCustomerM() {
      //  客户加收提交
      let index = this.lyArr.findIndex(
        (v) =>
          v.financeDocumentstatusId ===
          this.customerForm.financeDocumentstatusId
      );
      this.customerForm.financeDocumentstatusName = this.lyArr[
        index
      ].documentStatusName;
      if (this.isCustomer) {
        delete this.customerForm.userName;
        this.customerForm.sign = this.$TOOLS.getSign(this.customerForm);
        let param1 = {
          financeDocumentstatusId: this.customerForm.financeDocumentstatusId,
          financeDocumentstatusName: this.customerForm
            .financeDocumentstatusName,
          settlementAmount: this.customerForm.settlementAmount,
          userId: this.customerForm.userId,
          comment: this.customerForm.comment,
          documentNumber: this.customerForm.documentNumber,
          itemServiceId: this.customerForm.itemServiceId,
          serviceName: this.customerForm.serviceName,
          storageId: this.customerForm.storageId,
        };
        let sign = this.$TOOLS.getSign(param1);
        param1.sign = sign;
        this.$API.addCustomerAdditional(param1).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.isDT_addC = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        let param2 = {
          financeDocumentstatusId: this.customerForm.financeDocumentstatusId,
          financeDocumentstatusName: this.customerForm
            .financeDocumentstatusName,
          settlementAmount: this.customerForm.settlementAmount,
          customerAgentId: this.customerForm.customerAgentId,
          comment: this.customerForm.comment,
          documentNumber: this.customerForm.documentNumber,
          itemServiceId: this.customerForm.itemServiceId,
          serviceName: this.customerForm.serviceName,
          storageId: this.customerForm.storageId,
          customerAgentNumber: this.customerForm.customerAgentNumber,
        };
        let sign = this.$TOOLS.getSign(param2);
        param2.sign = sign;
        this.$API.addAgentAdditional(param2).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.isDT_addC = false;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },

    //代理加收 (跳转代理加收)
    dailijiashou() {
      this.$router.push({
        path: "/PayableManagement/AgencyApplication",
      });
    },

    //        ----------   计算表格高度    -------------

    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      console.log("tabHeight");
      console.log(tabHeight);
      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.tableHeigthRight = tabHeight - 40;
        this.$refs.mytable.doLayout();
      });
    },
  },
};
</script>

<style scoped lang="less">
.contentInner {
  width: 100%;
  display: flex;

  .rightInner {
    width: 200px;
    margin-right: 16px;
    cursor: pointer;
  }

  .leftInner {
    width: 80%;
    overflow: auto;
    /deep/ .el-tabs__item {
      height: 36px;
      line-height: 36px;
      background-color: #f4f4f4;
    }

    /deep/ .el-tabs__content {
      padding: 16px;
    }

    /deep/ .el-descriptions {
      margin-bottom: 10px;
    }
  }
}

/*
    查询轨迹-查询表单
    */
.queryBox {
  margin-top: 20px;
}

.showBox {
  margin-left: 20px;

  .countryGrounp {
    display: flex;

    .countryItem {
      min-width: 100px;
      background-color: #cfcfcf;
      padding: 10px;
    }

    .number {
      min-width: 100px;
      background-color: #ababab;
      padding: 10px;
      font-weight: bold;
      font-size: 16px;
      color: #fff;
    }
  }
}

.contentBox {
  width: 80%;
  margin-top: 20px;
}

.customerForm {
  .queryItem1 {
    margin: 0 auto;
    width: 60%;
    margin-bottom: 10px;
  }
}

.titles1 {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 20px;
}

.activeLeft {
  color: #f0a261;
}

.upLoadForm {
  display: flex;
  flex-wrap: wrap;

  /deep/ .el-upload-dragger .el-icon-upload {
    margin: 40px 0 10px;
  }

  /deep/ .el-upload {
    line-height: 40px;
  }
}

.glo_form .queryItems {
  width: 270px;
  /deep/ .el-input__inner {
    width: 166px;
  }
}
.lookImgs {
  color: blue;
  cursor: pointer;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #333;
}

.h3title {
  font-size: 16px;
  font-weight: 700;
  margin: 10px 0 6px;
  width: 100%;
}
.desclass {
  display: inline-block;
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
